fragment MediumTopicFeatureFragment on mediumTopicFeature_Entry {
  id
  typeHandle
  heading
  articlesHeading
  articles {
    ...ArticlePreviewFragment
  }
  cta {
    ...LinkFragment
  }
  image {
    url
    title
  }
}
